import {Controller} from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { english } from "flatpickr/dist/l10n/default.js";
import { Lithuanian } from "flatpickr/dist/l10n/lt.js";
import { Russian } from "flatpickr/dist/l10n/ru.js"

export default class extends Controller {
    connect() {
        const config = {
            locale: this.getLocale(),
            dateFormat: "Y-m-d",
            disableMobile: true,
        };

        if (this.element.dataset.min) {
            config['minDate'] = this.element.dataset.min;
        } else {
            config['minDate'] = '1901-01-01';
        }

        if (this.element.dataset.max) {
            config['maxDate'] = this.element.dataset.max;
        }

        if (this.element.dataset.format) {
            config['dateFormat'] = this.element.dataset.format;
        }

        if (this.element.dataset.format) {
            config['enableTime'] = this.element.dataset.enableTime;
        }

        if (this.element.hasAttribute('data-inline')) {
            config['inline'] = true;
        }

        if (this.element.dataset.mode) {
            config['mode'] = this.element.dataset.mode;
            // config['onChange'] = (selectedDates, datestr)=> {
            //     //this.element.value = selectedDates[0].toISOString().split('T')[0] + ' - ' + selectedDates[1].toISOString().split('T')[0];
            // }
        }

        if (!this.element.hasAttribute('readonly')) {
            flatpickr(this.element, config);
        }
    }

    getLocale () {
        switch (document.documentElement.lang.split('-')[0]) {
            case 'lt':
                return Lithuanian;
            case 'en':
                return english;
            case 'ru':
                return Russian;
            default:
                return Lithuanian;
        }
    }

    formatDate(date) {
        return date.toISOString().split('T')[0];
    }
}
